// ----------------------------------------------------------------------
// 🗂️ Initial Menus Data
// Contains the default structure for new projects
// ----------------------------------------------------------------------

const mainSitemapTree = {
  id: 'root',
  label: 'Home',
  type: 'root',
  children: [
    {
      id: 'about',
      label: 'About',
      type: 'page',
      children: []
    },
    {
      id: 'contact',
      label: 'Contact',
      type: 'page',
      children: []
    }
  ]
};

// New projects now start with ONLY this single sitemap
export const initialMenus = [
  {
    id: 'main-menu',
    title: 'Main Sitemap',
    tree: mainSitemapTree
  }
];